function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BaseFeaturesComponent } from './base-features.component';
export var BaseFiltrosComponent = /*#__PURE__*/function (_BaseFeaturesComponen) {
  function BaseFiltrosComponent($log, appConfigService) {
    var _this;
    _classCallCheck(this, BaseFiltrosComponent);
    _this = _callSuper(this, BaseFiltrosComponent, [appConfigService]);
    _defineProperty(_this, "listado", null);
    _defineProperty(_this, "listadolist", []);
    _defineProperty(_this, "filtroActivo", null);
    _defineProperty(_this, "filtroFechas", {
      visible: false,
      inicio: null,
      fin: null
    });
    _defineProperty(_this, "mainq", {
      $load: null,
      list: []
    });
    _defineProperty(_this, "filtroQ", {
      visible: false,
      mainq: null,
      value: null
    });
    _this.$log = $log;
    return _this;
  }
  _inherits(BaseFiltrosComponent, _BaseFeaturesComponen);
  return _createClass(BaseFiltrosComponent, [{
    key: "aplicaFiltros",
    value: function aplicaFiltros() {
      this._busqueda();
    }
  }, {
    key: "filtrarFechas",
    value: function filtrarFechas(forzar) {
      this.filtroFechas.visible = forzar !== null && forzar !== void 0 ? forzar : !this.filtroFechas.visible;
    }
  }, {
    key: "filtrarPorMainQ",
    value: function filtrarPorMainQ(forzar) {
      this.filtroQ.visible = forzar !== null && forzar !== void 0 ? forzar : !this.filtroQ.visible;
      if (this.filtroQ.visible && this.mainq.list.length) {
        this.filtroQ.mainq = this.mainq.list[0].data_mq.idmainq;
        this._updateSelect();
      }
    }
  }]);
}(BaseFeaturesComponent);